<div class="container">
  <div class="header">
    <div class="logo">
      <img src="assets/images/logo.svg" alt="Logo">
    </div>
  </div>
  <div class="pdf-container">
    <iframe *ngIf="language==Language.he" src="assets/docs/PRIVACY_POLICY-he.html"
    class="iframe">
    </iframe>
    <iframe *ngIf="language!=Language.he" src="assets/docs/PRIVACY_POLICY-en.html"
    class="iframe">
    </iframe>
  </div>
</div>